import { UntypedFormGroup } from '@angular/forms';

export interface FloorFGModel {
  floorId: number;
  floorIndex: number;
  floorNumber: string;
  floorName: string;
  hideFloor: boolean;
  floorSize: ValueUOMFG;
  floorPlan: FloorPlanModel;
  floorHeight: ValueUOMFG;
  floorGrossArea: ValueUOMFG;
}

export interface FloorPlanModel {
  link: string;
  name: string;
}

export interface ValueUOMFG {
  val: number;
  uom: string;
}

export interface SelectedFloor {
  floorGroup: UntypedFormGroup;
  floorIndex: number;
}

export interface ConflictSpaces {
  floorIndex: number;
  floorNumber: string;
  elevatorStop: boolean;
  spaces: FloorDetails[];
}

export interface FloorDetails {
  spaceId: string;
  spaceType: string;
  url: string;
}

export enum IncreaseDecreaseFloors {
  Increase = 'increase',
  Decrease = 'decrease',
}

export enum AboveBelow {
  Above = 'above',
  Below = 'below',
}

export const FLOOR_HEADERS = [
  {
    field: 'selectFloor',
    header: '',
    headerClass: 'radio-header',
    colClass: 'radio-col',
  },
  {
    field: 'floorNumber',
    header: 'moreInfo.floorNumber',
    headerClass: 'floor-name-header',
    colClass: 'floor-name-col',
  },
  {
    field: 'floorDesc',
    header: 'moreInfo.floorName',
    headerClass: 'floor-name-header',
    colClass: 'floor-name-col',
  },
  {
    field: 'floorGrossArea',
    header: 'moreInfo.floorGrossArea',
    headerClass: 'floor-size-uom-header',
    colClass: 'floor-size-uom-col',
  },
  {
    field: 'floorSize',
    header: 'moreInfo.floorRentableArea',
    headerClass: 'floor-size-uom-header',
    colClass: 'floor-size-uom-col',
  },
  {
    field: 'floorHeight',
    header: 'moreInfo.height',
    headerClass: 'floor-size-uom-header',
    colClass: 'floor-size-uom-col',
  },
  {
    field: 'floorImage',
    header: 'moreInfo.addRemoveFloorPlan',
    headerClass: 'add-remove-header',
    colClass: 'add-remove-col',
  },
  {
    field: 'floorHide',
    header: 'moreInfo.hiddenFloor',
    headerClass: 'add-remove-header',
    colClass: 'add-remove-col',
  },
];
